import { createStore } from 'vuex'
import AccountStoreV2 from './AccountStoreV2'
import FuryuBannerStore from './FuryuBannerStore'
import PuriSealsStore from './PuriSealsStore'
import JhsFreeStore from './JhsFreeStore'
import JhsFreeEntryStore from './JhsFreeEntryStore'
import NewsStore from "./NewsStore";
import PictlinkAdStore from "./PictlinkAdStore";

const modules = {
    modules: {
        AccountStoreV2,
        FuryuBannerStore,
        PuriSealsStore,
        JhsFreeStore,
        JhsFreeEntryStore,
        NewsStore,
        PictlinkAdStore
    }
};
const Store = createStore(modules);

export { Store, modules }
